var $86befe85692caa5e$exports = {};
$86befe85692caa5e$exports = {
    "removeDescription": `Press Delete to remove tag.`,
    "removeButtonLabel": `Remove`
};


export {$86befe85692caa5e$exports as default};
//# sourceMappingURL=en-US.mjs.map
